import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../services/util.service';

@Pipe({
  name: 'timeFormatter'
})
export class TimeFormatterPipe implements PipeTransform {

  constructor(private utilService: UtilService) {}

  transform(value: string): string {
    if (value) {
      const timeStr = value.split(' ')[1];
      const timeArr = timeStr.split('/');
      const hour = Number(timeArr[0]);
      const minutes = timeArr[1];
      const period = hour > 11 ? 'PM' : 'AM';
      const formattedHour = this.utilService.prependZero(hour === 0 ? 12 : (hour > 12 ? hour - 12 : hour));
      return formattedHour + ':' + minutes + ' ' + period;
    }
    return '-';
  }

}
